
import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
class HDeviceInfo {
    static instance;

    constructor() {
        if (HDeviceInfo.instance) {
            return HDeviceInfo.instance;
        }
        HDeviceInfo.instance = this;
    }

    deviceModal = "";

    appVersion = "";

    // 平台标识
    // 0：未知；
    // 3：h5-ios；
    // 4：h5-android；
    // 5：h5-pc；
    platTypeNo = 0;

    deviceInfo = "";

    //设备真实唯一不变id
    deviceNoChangeId = "";

    //设备唯一id
    deviceId = "";

    //渠道标识(app_id 需要约束下，必须是4位长度的字符串，线数字、纯字母、数字字母组合都可以。)
    channelFlag = "";

    //邀请码
    inviteCode = "";

    //是否首页不需要提示下载按钮,false = 提示，true 不提示
    h2d = false;

    //是否强制显示首页的下载按钮
    fsd = false;

    //是否运行在桌面
    isRunDesktop = false;

}

export const hdi =  new HDeviceInfo();
